<template lang="pug">
.bloco-ativos-ambientais
    .bloco-ativos-ambientais__titulo
        .bloco-ativos-ambientais__titulo--interno
            span Total de Imóveis:
            span.negrito {{ ImoveisValor }}

    .bloco-ativos-ambientais__conteudo
        .bloco-ativos-ambientais__conteudo--esquerdo
            span.barra-topo Área de reserva legal
            span.valor__negrito {{ areaReserva }}

    .bloco-ativos-ambientais__alinhamento
        .bloco-ativos-ambientais__alinhamento--conteudo
            span.barra-topo Área de APP
            span.valor__negrito {{ areaApp }}
        .bloco-ativos-ambientais__alinhamento--conteudo
            span.barra-topo Área de excedente de vegetação nativa
            span.valor__negrito {{ vegetacao }}
        .bloco-ativos-ambientais__alinhamento--conteudo
            span.barra-topo Potencial de estoque de carbono
            span.valor__negrito {{ carbono }}
</template>

<script>
export default {
    name: 'BlocoAtivosAmbientais',
    props: {
        ImoveisValor: {
            type: String,
            default: () => ''
        },
        areaReserva: {
            type: String,
            default: () => ''
        },
        areaApp: {
            type: String,
            default: () => ''
        },
        vegetacao: {
            type: String,
            default: () => ''
        },
        carbono: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.bloco-ativos-ambientais {
    width: 100%;
    background: var(--white);
    border-radius: 5px;
    display: flex;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding: 12px 10px 20px;
    flex-direction: column;
    height: 405px;
    .bloco-ativos-ambientais__titulo {
        display: flex;
        padding-bottom: 8px;
    }
    .bloco-ativos-ambientais__titulo--interno {
        font-size: 14px;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        width: 80%;
        .negrito {
            font-weight: 600;
            font-size: 20px;
            color: var(--primary);
        }
    }
    .bloco-ativos-ambientais__conteudo {
        display: flex;
        margin-bottom: 15px;
        &--esquerdo {
            display: flex;
            flex-direction: column;
            min-width: 58%;
        }
        &--direito {
            display: flex;
            flex-direction: column;
        }
        .valor__negrito {
            font-weight: 700;
            color: var(--primary);
        }
    }
    .bloco-ativos-ambientais__alinhamento {
        display: flex;
        flex-direction: column;

        &--conteudo {
            display: flex;
            flex-direction: column;
            margin-bottom: 15px;
        }
        .valor__negrito {
            font-weight: 700;
            color: var(--primary);
        }
    }
    .barra-topo::before {
        content: '';
        display: flex;
        width: 24px;
        height: 2px;
        background: var(--secondary-two);
        clear: both;
        margin-bottom: 5px;
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
}
</style>
